export const VendaModais = {
  cadastrarVenda: 'cadastrarVenda',
  visualizarVenda: 'visualizarVenda',
  enviarOrcamento: 'enviarOrcamento',
  buscaAvancada: 'buscaAvancada',
};
